module.exports = __webpack_public_path__ + "img/6.3390877e.png";